import React from 'react';

// Classnames
import clsx from 'clsx';

// components
import HeaderList from './HeaderList';
import Loader from 'components/UiKit/Loader';
import CartPfizerContainer from 'components/Carts/CartPfizer';

export const List: React.FC<any> = (props) => {
	const { type, data, page, size, loading } = props;

	if (loading) {
		return <div className="pfizer__loader-dna relative full-width flex flex-ai-center flex-jc-center">
			<Loader
				color="white"
				type="small"
			/>
		</div>;
	}

	if (!data?.length) return <></>;

	return (
		<div className="full-width">
			<div className={clsx(
				'pfizer__list-content flex flex-direction-column full-width'
			)}>
				<HeaderList />
				<div className={clsx(
					'pfizer__items',
					type === 'cart' ? 'pfizer__items--active flex-wrap' : '',
					type === 'row' ? 'flex-ai-start flex-direction-column' : ''
				)}>
					{data?.map((item: any, index: number) => {
						const numeration = `${page * +size + index + 1}`;
						return <CartPfizerContainer
							key={item.id}
							{...item}
							type={type}
							numeration={numeration}
							classNameWrapper="pfizer__numeration"
							uniqId={index === 1 ? 'categorized-products-package-cart-price' : ''}
							uniqIdCheckbox={index === 1 ? 'categorized-products-package-checkbox' : ''}
						/>;
					})}
				</div>
			</div>
		</div>
	);
};

export default List;
